var pickerBox;
var fncFileDown; // 4.0에 있던 함수, 사용여부 확인하여 불필요하면 삭제 해 주세요.
$(document).ready(function() {
	if(!document.querySelector('.search-model-result')) return false;

	var $cont = $(document.querySelector('.search-model-result')),
		$resultBox = $('#resultSelectArea'),
		$tabs = $('.tabs-type-liner'),
		json = $tabs.data('url'),
		$tablinks = $tabs.find('a'),
		HTML = new Array(),
		previousName = new Array(),
		previousParent = new Array(),
		pageView=1,
		error = {
			start: null,
			end: null
		};

	// Detail
	var selectResult = {
		accordionArea: document.getElementsByClassName('result-accordion'),
		referenceToggle: function(e){
			e.preventDefault();
			var $target = $(e.target);

			/* PJTWAUS-6 20200205 modify */
			if( $target.hasClass('active') ){
				$target.removeClass('active');
				
				if ($target.is('[aria-expanded]')) {
					$target.attr('aria-expanded', false);
				}
			} else {
				$target.addClass('active');
				
				if ($target.is('[aria-expanded]')) {
					$target.attr('aria-expanded', true);
				}
			}
			/*// PJTWAUS-6 20200205 modify */
			$target.closest('.file-reference').find('.reference-desc').collapse('toggle');
		},
		accordionToggle: function(e){
			e.preventDefault();
			var $target = $(e.target);

			/* PJTWAUS-6 20200205 modify */
			if( $target.hasClass('active') ){
				$target.removeClass('active');
				
				if ($target.is('[aria-expanded]')) {
					$target.attr('aria-expanded', false);
				}
			} else {
				$target.addClass('active');
				
				if ($target.is('[aria-expanded]')) {
					$target.attr('aria-expanded', true);
				}
			}
			/*// PJTWAUS-6 20200205 modify */
			$target.closest('.accordion-box').find('.accordion-desc').collapse('toggle');
		},
		activeEvent: function(){
			// Accordion Toggle
			$(selectResult.accordionArea).find('.accordion-title .toggle_text').off('click').on('click', selectResult.accordionToggle);
			$(selectResult.accordionArea).find('.file-reference .link-text').off('click').on('click', selectResult.referenceToggle);

			// Operating Systems Select
			runChosen();
			$(selectResult.accordionArea).find('.sort-area select').off('change').on({
				'change': function(e){
					e.preventDefault();

					var selectArea = document.getElementById('select_os_form');
					var url = selectArea.getAttribute('data-url');
					var param = $(selectArea).serialize();
					ajax.call(url, param, 'html', function(data){
						if(data.result != undefined && data.error.type == "downtime") {
							error.start = data.error.startTime;
							error.end = data.error.endTime;
							pickerBox.errorPage(null, null, true);
							return false;
						}
						$(selectArea).find('.file-area').html(data);
						$(selectResult.accordionArea).find('.file-reference .link-text').off('click').on('click', selectResult.referenceToggle);
					}, null, 'body');
				}
			});

			// PC sync : Operating Systems Select(Radio)
			$(selectResult.accordionArea).find('.radio-button input').off('click').on({
				'click': function(){
					var selectArea = document.getElementById('software_os_form');
					var url = selectArea.getAttribute('data-url');
					var param = $(selectArea).serialize();

					ajax.call(url, param, 'html', function(data){
						if(data.result != undefined && data.error.type == "downtime") {
							error.start = data.error.startTime;
							error.end = data.error.endTime;
							pickerBox.errorPage(null, null, true);
							return false;
						}
						$(selectArea).find('.sync-area').html(data);
					}, null, 'body');
				}
			});
		}
	};

	// List
	pickerBox = {
		detailURL: $resultBox.data('detail'),
		filterCPURL: $resultBox.data('filter-cp'),
		filterConsumerURL: $resultBox.data('filter'),
		filterBusinessURL: $resultBox.data('filter-b2b'),
		goBackTemp: $cont.find('.template .search-depth-stack .phase-reload').get(0).outerHTML,
		selectTemp: $cont.find('.template .search-depth-stack .change-filter').get(0).outerHTML,
		pageTemp: $cont.find('.template .search-depth-stack .pagination').get(0).outerHTML,
		noContentDetailTemp: $cont.find('.template .no-content-detail').get(0).outerHTML,
		noContentListTemp: $cont.find('.template .no-content-list').get(0).outerHTML,
		downtimeError: $cont.find('.template .error-common').get(0).outerHTML,
		init: function() {
			if($resultBox.find('.search-result-area').length==0) {
				// model code 없이 들어온 경우
				ajax.call(json, {}, 'json', function(data, _this){
					if(data.result != undefined && data.error.type == "downtime") {
						error.start = data.error.startTime;
						error.end = data.error.endTime;
						pickerBox.errorPage(null, null, true);
						return false;
					}
					$ajaxData = data;
					pickerBox.getData($ajaxData);
					pickerBox.viewList('business', 'none');
					//pickerBox.step1(pickerBox.menu);
				}, 'get', 'body');
			} else {
				var htmlObj = $resultBox.find('.search-result-area');
				var m = htmlObj.data('model'),
					c = htmlObj.data('category'),
					s1 = htmlObj.data('salesmodelcode'),
					s2 = htmlObj.data('salessuffixcode');
					
				this.model(m, c, s1, s2);

				// detail 먼저 처리하고, 나중에 목록 불러 옴.
				ajax.call(json, {}, 'json', function(data, _this){
					if(data.result != undefined && data.error.type == "downtime") {
						error.start = data.error.startTime;
						error.end = data.error.endTime;
						pickerBox.errorPage(null, null, true);
						return false;
					}
					$ajaxData = data;
					pickerBox.getData($ajaxData);
				}, 'get', 'body');
			}
			// bind click event on consumer and business
			$tablinks.on('click', function(e) {
				e.preventDefault();
				var menu = $(this).data('menu');
				if(menu=='consumer') {
					pickerBox.viewList('consumer', 'none');
				} else {
					pickerBox.viewList('business', 'none');
				}
			});
		},
		getData: function(data) {
			// depth1
			for(var i=0;i<data.length;i++) {
				// make List HTML
				HTML[data[i].type] = '<ul class="search-result-group">';
				for(var j=0;j<data[i].list.length;j++) {
					/* PJTWAUS-6 : 20200203 modify */
					if(!data[i].list[j].categoryId) {
						HTML[data[i].type] = HTML[data[i].type] + '<li class="box-result-item"><a href="#" data-name="'+(data[i].list[j].name)+'" data-biztype="'+(data[i].list[j].biztype)+'" data-parent="'+(data[i].list[j].parent)+'" data-child="'+(data[i].list[j].type)+'"><div class="image-box"><span><img alt="'+(data[i].list[j].name)+'" class="lazyload" data-src="'+(data[i].list[j].image)+'" aria-hidden="true"></span></div><div class="text-box"><span class="name">'+(data[i].list[j].name)+'</span></div></a></li>';
					} else {
						HTML[data[i].type] = HTML[data[i].type] + '<li class="box-result-item"><a href="#" data-name="'+(data[i].list[j].name)+'" data-biztype="'+(data[i].list[j].biztype)+'" data-parent="'+(data[i].list[j].parent)+'" data-child="'+(data[i].list[j].type)+'" data-sort="'+(data[i].list[j].sort)+'" data-cate="'+(data[i].list[j].categoryId)+'" data-filter="'+(data[i].list[j].filter)+'"><div class="image-box"><span><img alt="'+(data[i].list[j].name)+'" class="lazyload" data-src="'+(data[i].list[j].image)+'" aria-hidden="true"></span></div><div class="text-box"><span class="name">'+(data[i].list[j].name)+'</span></div></a></li>';
					}
					/*// PJTWAUS-6 : 20200203 modify */
				}
				HTML[data[i].type] = HTML[data[i].type] + '</ul>';

				// previous Name
				for(var j=0;j<data[i].list.length;j++) {
					previousName[data[i].list[j].type] = data[i].list[j].name;
					previousParent[data[i].list[j].type] = data[i].list[j].parent;
				}
			}
		},
		viewPreviousHTML: function(menu, parent) {
			//console.log('viewPreviousHTML', menu, parent);
			if(menu!='consumer' && menu!='business') {
				var goBackHTML='<div class="search-depth-stack">'+this.goBackTemp+'</div>';
				if(parent!='consumer' && parent!='business' && menu!='cp') {
					// 이 조건일때 select box 추가
					goBackHTML='<div class="search-depth-stack">'+this.goBackTemp+this.selectTemp+'</div>';
				}
				$resultBox.append(goBackHTML)
					.addClass('active')
					.find('.search-depth-stack').addClass('active')
					.find('.name-of-phase').html(previousName[menu]);
				// if(mode=='DISCONTINUED') {
				// 	$resultBox.find('.change-filter select option:eq(0)').prop('selected', false);
				// 	$resultBox.find('.change-filter select option:eq(1)').prop('selected', true);
				// }
				$resultBox.find('.search-depth-stack .phase-reload button').on('click', function(e) {
					e.preventDefault();
					if(menu=='cp') {
						pickerBox.viewList(parent, 'parent of parent');
					} else {
						pickerBox.viewList(parent, 'parent of parent');
					}
				});
				// bind event for select
				var $select = $resultBox.find('.change-filter').addClass('active').find('select');
				$select.addClass('run-chosen').off('change').on('change', function() {
					var va = $(this).find('option:selected').val();
					//console.log($(this).data('biztype'));
					// if(va!="ACTIVE") {
						// DISCONTINUED
						pickerBox.viewListFilter($(this).data('child'), $(this).data('parent'), 1, $(this).data('sort'), $(this).data('biztype'), $(this).data('cate'), $(this).data('filter'));
					// } else {
					// 	// ACTIVE
					// 	pickerBox.viewListFilter($(this).data('child'), $(this).data('parent'), 1, $(this).data('sort'), $(this).data('biztype'), $(this).data('cate'), $(this).data('filter'));
					// }
				});
				runChosen();
			}
		},
		viewList: function(menu, parent) {
			$resultBox.empty();
			// console.log('viewList', menu, parent);
			// static list
			if(menu!='consumer' && menu!='business') {
				pickerBox.viewPreviousHTML(menu, previousParent[menu]);
			}
			if(HTML[menu] == undefined) {
				pickerBox.errorPage(null, null, true);
			}
			$resultBox.append(HTML[menu]);
			if(menu=='consumer' || menu=='business') {
				// step1
				$resultBox.find('ul li a').on('click', function(e) {
					e.preventDefault();
					pickerBox.viewList($(this).data('child'), $(this).data('parent'));
					adobeTrackEvent('cs-category-browse', {page_event : {cs_category_browse : true}});
				});
			} else {
				// step2 or later
				$resultBox.find('ul li a').on('click', function(e) {
					e.preventDefault();
					pickerBox.viewListFilter($(this).data('child'), $(this).data('parent'), 1, $(this).data('sort'), $(this).data('biztype'), $(this).data('cate'), $(this).data('filter'));
				});
			}
			pickerBox.fitAlign();
		},
		viewListFilter: function(menu, parent, page, sort, biztype, cate, filter) {
			//console.log(page, 'page');
			if(!page || page==1) {
				$resultBox.empty();
				// if(!mode) mode = "ACTIVE";
				//
				// previous
				pickerBox.viewPreviousHTML(menu, previousParent[menu]);
			}
			// list
			if(menu=='cp') {
				// cell phone (예외)
				var CPcate=$resultBox.data('category');
				ajax.call(pickerBox.filterConsumerURL+'?sort=&viewAll=Y&modelStatusCode=ACTIVE&bizType=B2C&categoryId='+CPcate, {}, 'json', function(data, _this){
					if(!data) {
						pickerBox.errorPage(menu, 'list');
					} else if(data.result != undefined && data.error.type == "downtime") {
						pickerBox.errorPage(null, null, true);
						return false;
					}else {
						HTML[menu] = '<ul class="search-result-group model">';
						var data = data.data[0].filterList;
						//console.log(data.length);
						if(data.length>0) {
							HTML['cp'] = '<ul class="search-result-group cellphone-case">';

							// for all phones
							HTML['cp'] = HTML['cp'] + '<li class="box-result-item"><a href="#" data-parent="cp" data-child="cp_ap" data-sort="0" data-biztype="B2C" data-cate="'+CPcate+'" data-filter="" data-name="All Phones"><div class="text-box"><span class="name">All Phones</span></div></a></li>';
							previousName['cp_ap'] = 'All Phones';
							previousParent['cp_ap'] = 'cp';

							var tempArrayforCP = [];
							tempArrayforCP['id'] = new Array();
							tempArrayforCP['valueId'] = new Array();
							tempArrayforCP['valueName'] = new Array();
							tempArrayforCP['isDuplicated'] = new Array();
							for(var i=0;i<data.length;i++) {
								if(i>0 && data[i].filterValueName == data[i-1].filterValueName) {
									tempArrayforCP['isDuplicated'][i-1] = true;
									continue;
								}
								tempArrayforCP['id'][i] = data[i].filterId;
								tempArrayforCP['valueId'][i] = data[i].filterValueId;
								tempArrayforCP['valueName'][i] = data[i].filterValueName;
								tempArrayforCP['isDuplicated'][i] = false;
							}
							for(key in tempArrayforCP['id']) {
								var isDup = (tempArrayforCP['isDuplicated'][key]) ? 'V' : '';
								HTML['cp'] = HTML['cp'] + '<li class="box-result-item"><a href="#" data-parent="cp" data-child="cp_'+key+'" data-sort="0" data-biztype="B2C" data-cate="'+CPcate+'" data-filter="'+tempArrayforCP['id'][key]+'='+tempArrayforCP['valueId'][key]+isDup+'" data-name="'+tempArrayforCP['valueName'][key]+'"><div class="text-box"><span class="name">'+tempArrayforCP['valueName'][key]+'</span></div></a></li>';
								previousName['cp_'+key] = tempArrayforCP['valueName'][key];
								previousParent['cp_'+key] = 'cp';
							}
							/*
							for(var i=0;i<data.length;i++) {
								if(i>0 && data[i].filterValueName == data[i-1].filterValueName) {
									continue;
								}
								HTML['cp'] = HTML['cp'] + '<li class="box-result-item"><a href="#" data-parent="cp" data-child="cp_'+i+'" data-sort="0" data-biztype="B2C" data-cate="'+CPcate+'" data-filter="'+(data[i].filterId)+'='+(data[i].filterValueId)+'" data-name="'+(data[i].filterValueName)+'"><div class="text-box"><span class="name">'+(data[i].filterValueName)+'</span></div></a></li>';
								previousName['cp_'+i] = data[i].filterValueName;
								previousParent['cp_'+i] = 'cp';
							}
							*/
							HTML['cp'] = HTML['cp'] + '</ul>';
							$resultBox.append(HTML['cp']);
							bindImgError();
							$resultBox.find('ul li a').on('click', function(e) {
								e.preventDefault();
								pickerBox.viewListFilter($(this).data('child'), $(this).data('parent'), 1, $(this).data('sort'), $(this).data('biztype'), $(this).data('cate'), $(this).data('filter'));
							});
							pickerBox.fitAlign();
						} else {
							// error
							pickerBox.errorPage(menu, 'list');
						}
					}
				}, null, 'body');
			} else {
				// etc
				var myurl='', modelFilter="B"; 
				if(biztype.toUpperCase()!='B2B') {
					myurl=pickerBox.filterConsumerURL;
				} else {
					myurl=pickerBox.filterBusinessURL;
				}
				//if(/^CT*/.exec(cate) == null) {
				//	myurl=pickerBox.filterBusinessURL;
				//} else {
				//	myurl=pickerBox.filterConsumerURL;
				//}
				var ajaxUrl;
				if(filter) {
					ajaxUrl = myurl+'?sort='+sort+'&viewAll=Y&categoryId='+cate+'&bizType='+biztype.toUpperCase()+'&'+filter;
				} else {
					ajaxUrl = myurl+'?sort='+sort+'&viewAll=Y&categoryId='+cate+'&bizType='+biztype.toUpperCase();
				}
				ajax.call(ajaxUrl, {}, 'json', function(data, _this){
					if(!data) {
						pickerBox.errorPage(menu, 'list');
					} else if(data.result != undefined && data.error.type == "downtime") {
						pickerBox.errorPage(null, null, true);
						return false;
					} else {
						HTML[menu] = '<ul class="search-result-group model">';
						var len = 15;
						var ww = $(window).width();
						if(ww >= 992) len = 5*3;
						else if(ww >= 768) len = 4*3;
						else if(ww >= 481) len = 3*3;
						else len = 2*3;
						var data = data.data[0].productList;
						var all = data.length;
						//console.log(all);
						//all=0;
						if(all>0) {
							var start = start=(len*(page-1));
							var pageAll = parseInt((all-1)/len)+1;
							var pageLimit = parseInt((pageAll-1)/5)+1;
							//console.log(pageAll)
							//var ismore = false;
							var end = (start+len);
							if(start+len >= all) {
								end=all;
							//	ismore=false;
							} else {
								end=(start+len);
							//	ismore=true;
							}
							//console.log(page, start, end, all);
							//console.log(page, start, end, all);
							var modelTypeArray = data.map(function(model) {
                                return model.modelType;
                            });
                            var onlyModelB = modelTypeArray.every(function(type) {
                                return type == modelFilter;
                            });
							
							for(var i=start;i<end;i++) {
								var userFriendlyName = data[i].userFriendlyName && data[i].userFriendlyName != null ? data[i].userFriendlyName.replace(/\"/g, '\'\'') : data[i].userFriendlyName;
								var imageAltText = data[i].imageAltText && data[i].imageAltText != null ? data[i].imageAltText.replace(/\"/g, '\'\'') : data[i].imageAltText;
								if(data[i].modelType != modelFilter)
									HTML[menu] = HTML[menu] + '<li class="box-result-item"><a href="'+(data[i].modelUrlPath)+'" data-model="'+(data[i].modelId)+'" data-name="'+(userFriendlyName)+'" data-salesmodelcode="'+(data[i].salesModelCode)+'" data-salessuffixcode="'+(data[i].salesSuffixCode)+'"><div class="image-box"><span><img class="lazyload" data-src="'+(data[i].mediumImageAddr)+'" alt="'+(imageAltText)+'" aria-hidden="true"></span></div><div class="text-box"><span class="name">'+(userFriendlyName)+'</span><span class="model-number">'+(data[i].modelName)+'</span></div></a></li>';
							}
							//if(!page || page==1) {
								HTML[menu] = HTML[menu] + '</ul>';
							//}
							if (onlyModelB == true) {
                                pickerBox.errorPage(null, null, !0);
                            }

							HTML[menu] = xssfilter(HTML[menu], true);

							if(!page || page==1) {
								$resultBox.append(HTML[menu]);
								bindImgError();
							} else {
								$resultBox.find('.search-result-group').empty().replaceWith(HTML[menu]);
								bindImgError();
							}
							//$resultBox.find('.pagination').remove();
							//if(ismore) {
							//	$resultBox.append(pickerBox.pageTemp);
							//}
							if(page==1) {
								$resultBox.append(pickerBox.pageTemp);
								for(var i=1;i<=pageAll;i++) {
									var _ariaText = '';
									if($resultBox.find('.pagination').attr('data-aria-pattern')) {
										_ariaText = 'aria-label="' + $resultBox.find('.pagination').attr('data-aria-pattern').replace(/\#/g, i) + '"';
									}
									/* PJTWAUS-6 : 20200203 modify */
									if(i==1) {
										$resultBox.find('.pagination ul').append('<li><button type="button" data-page="1" class="active" aria-selected="true" '+_ariaText+'>1</button></li>');
									} else {
										$resultBox.find('.pagination ul').append('<li><button type="button" data-page="'+i+'" '+_ariaText+'>'+i+'</button></li>');
									}
									/*// PJTWAUS-6 : 20200203 modify */
								}
							}
							$resultBox.find('ul li a').off('click').on('click', function(e) {
								e.preventDefault();
								pickerBox.model($(this).data('model'), cate, $(this).data('salesmodelcode'), $(this).data('salessuffixcode'));
							});
							pickerBox.fitAlign();
							$resultBox.find('.pagination ul li button').off('click').on('click', function(e) {
								e.preventDefault();
								var current = $(this).data('page');
								pickerBox.viewListFilter(menu, parent, current, sort, biztype, cate, filter);
								/* PJTWAUS-6 : 20200203 modify */
								$(this).closest('.pagination').find('li button').removeClass('active').removeAttr('aria-selected');
								$(this).addClass('active').attr('aria-selected', 'true');
								
								var prevArrow = $resultBox.find('.pagination button[class="prev"]');
								var nextArrow = $resultBox.find('.pagination button[class="next"]');
								var totalPageLength = $(this).closest('.pagination').find('ul li').length;
								
								if (prevArrow !== undefined && nextArrow !== undefined && prevArrow.length > 0 && nextArrow.length > 0) {
									if (current == totalPageLength) {
										nextArrow.attr('aria-disabled', true);
									} else {
										nextArrow.attr('aria-disabled', false);
									}
									
									if (current == 1 || totalPageLength == 1) {
										prevArrow.attr('aria-disabled', true);
									} else {
										prevArrow.attr('aria-disabled', false);
									}
								}
								/*// PJTWAUS-6 : 20200203 modify */
								// control focus
								$resultBox.find('.search-result-group').attr('tabIndex', 0).focus();
							});
							
							/* PJTWAUS-6 : 20200203 add */
							if (pageAll == 1) {
								$resultBox.find('.pagination button[class="next"]').attr('aria-disabled', true);
							}
							/*// PJTWAUS-6 : 20200203 add */
							
							$resultBox.find('.pagination > button').off('click').on('click', function(e) {
								e.preventDefault();
								if($(this).hasClass('prev')) {
									if (pageView <= 1) {
										return false;
									} else {
										pageView--;
									}
								} else {
									if (pageLimit <= pageView) {
										return false;
									} else {
										pageView++;
									}
								}
								replacePage(pageView);
							});
							function replacePage(view){
								$resultBox.find('.pagination ul li').hide();
								for (var i=(5*(view-1)); i<((5*(view-1))+5) ; i++ ) {
									$resultBox.find('.pagination ul li').eq(i).show();
								}
							}
						} else {
							// error
							pickerBox.errorPage(menu, 'list');
						}
					}
				}, null, 'body');
				if(parent!='consumer' && parent!='business' && menu!='cp') {
					// select box 가 추가될 때, select box에 조건들을 넣어 줌
					$resultBox.find('.change-filter select').data('child', menu).data('parent', parent).data('sort', sort).data('biztype', biztype).data('cate', cate).data('filter', filter);
				}
			}
		},
		model: function(modelId, cate, salesModelCode, salesSuffixCode) {
			$resultBox.empty();
			if(!cate) cate='';
			if (typeof modelId === 'string' && modelId.toLowerCase() === 'bcp2a') {
                salesModelCode = 'BCP2A';
            }
			ajax.call(pickerBox.detailURL, {customerModelCode:modelId, category:cate, salesModelCode:salesModelCode, salesSuffixCode:salesSuffixCode}, 'html', function(data, _this){
				current = $tabs.find('a.active');
				if(!data) {
					// error
					$resultBox.html(pickerBox.noContentDetailTemp).addClass('active').find('.red').html(xssfilter(modelId));
				} else if(data.result != undefined && data.error.type == "downtime") {
					pickerBox.errorPage(null, null, true);
					return false;
				} else {
					var detailData = $(data);
					$resultBox.html(detailData).addClass('active');
					selectResult.activeEvent();
				}
			}, null, 'body');
		},
		fitAlign: function() {
			var len = $resultBox.find('.search-result-group li').length;
			var standard = 5;
			var ww = $(window).width();
			if(ww >= 992) standard = 5;
			else if(ww >= 768) standard = 4;
			else if(ww >= 481) standard = 3;
			else standard = 2;
			if(standard >= len) {
				$resultBox.find('.search-result-group').addClass('center');
			} else {
				$resultBox.find('.search-result-group').removeClass('center');
			}
		},
		errorPage: function(menu, type, downtimeChk, startTime, endTime) {
			if (type=='list') {
				errorHtml = this.noContentListTemp;
				$resultBox.append(errorHtml);
			} else {
				$resultBox.empty();
				var errorHtml;
				if(downtimeChk) {
					errorHtml = this.downtimeError;
					$resultBox.append(errorHtml);
					$resultBox.find('.start-time').text(error.start);
					$resultBox.find('.end-time').text(error.end);
				} else if (type=='list') {
				}else {
					errorHtml = this.noContentDetailTemp;
					pickerBox.viewPreviousHTML(menu, previousParent[menu]);
					$resultBox.append(errorHtml).find('.red').html(previousName[menu]);
				}
			}
		}
	};
	pickerBox.init();

	var pageName = '';
	if($cont.data('menu')=='SoftwareDrivers') pageName = 'software_drivers';
	else if($cont.data('menu')=='ManualsDocumnets') pageName = 'manuals_documents';

	// adobe
	if(pageName != '') {
		// cs - software & drivers > popular software (popup)
		$('.support-wrap .modal .pop-drivers-wrap .product-info .text .download-btn-box a.btn').on('click', function() {
			var fileName = changeTitleFormat($(this).closest('.product-info').find('.text .title').text()) + ':' + changeTitleFormat($(this).text());
			adobeTrackEvent('cs-popular-software-download', {download_file_type : pageName, download_file_name: fileName, page_event : {cs_file_download : true}});
		});
		// cs - software & drivers > popular software (popup)
		$('.support-wrap .modal .pop-drivers-wrap .download_list ul.list li a.link-text').on('click', function() {
			var fileName = changeTitleFormat($(this).closest('.download_list').find('.title').text()) + ':' + changeTitleFormat($(this).text());
			adobeTrackEvent('cs-popular-software-download', {download_file_type : pageName, download_file_name: fileName, page_event : {cs_file_download : true}});
		});
		// cs - manuals & documents > popular manuals 
		$('.support-wrap .popular-manuals .manuals-box .manuals-pdf-list li a').on('click', function() {
			var fileName = 'popular_manuals:' + changeTitleFormat($(this).text());
			adobeTrackEvent('cs-popular-manuals-download', {download_file_type : pageName, download_file_name: fileName, page_event : {cs_file_download : true}});
		})
		// cs - detail 
		$('body').on('click.adobe1', '.search-result-area .file-list li .name .link-text', function() {
			var fileName = changeTitleFormat($(this).closest('.accordion-box').find('.accordion-title').text()) + ':' + changeTitleFormat($(this).closest('.result-accordion').find('> .title').text()) + ':' + changeTitleFormat($(this).text());
			adobeTrackEvent('cs-detail-download', {download_file_type : pageName, download_file_name: fileName, page_event : {cs_file_download : true}});

		}).on('click.adobe2', '.search-result-area .step-list li .btn-area a.btn', function() {
			var tmp = $(this).closest('.step-area').find('.step-title').text() ? $(this).closest('.step-area').find('.step-title').text() : $(this).closest('.accordion-desc').find('.desc-title').text();
			var fileName = changeTitleFormat(tmp) + ':' + changeTitleFormat($(this).closest('.result-accordion').find('> .title').text()) + ':' + changeTitleFormat($(this).text());
			adobeTrackEvent('cs-detail-download', {download_file_type : pageName, download_file_name: fileName, page_event : {cs_file_download : true}});
		});
	}
	/* PJTWAUS-1 20200312 add 스크린리더 id중복 삭제 */
	$('.template .change-filter > label').removeAttr('for');
	$('.template .change-filter > select').removeAttr('id');
	/* PJTWAUS-1 20200312 add */

	// 4.0 소스에 원래 들어있던 함수, 참고용
	/*
	fncFileDown = function(docId,fileName,originalName, fileSystemCode, filePath, downtimeChk, gcscDownUrl) {
		var flag = downtimeChk;
		var form = document.getElementById('formDownFile');
		originalName = originalName.replace(" ","_");
		for(var i=0;i<document.getElementsByName("DOC_ID").length;i++){
			document.getElementsByName("DOC_ID")[i].value = docId;
		}
		for(var j=0;j<document.getElementsByName("ORIGINAL_NAME_b1_a1").length;j++){
			document.getElementsByName("ORIGINAL_NAME_b1_a1")[j].value = originalName;
		}
		document.getElementById('what').value       = 'MANUAL';
		document.getElementById('fileId').value     = fileName;
		document.getElementById('fromSystem').value = 'LG.COM';
		if( fileSystemCode == 'GCSC') {
			if(flag == "Y") {
				location.href=gcscDownUrl;
				return false;
			} else {
				form.method = "get";
				form.target="_self";
				form.action="/us/lgecs.downloadFile.ldwf";
			}
		} else {
			var path = filePath;
			form.target="_blank";
			form.action =path;
		}
		form.submit();
		return false;
	};
	*/
});
